import React from 'react';
import ReactTooltip from 'react-tooltip';

const toolTipWrapper = (props) => {
	return <ReactTooltip place="top" effect="solid"/>;
}


export default toolTipWrapper;